<!-- Custom spinner -->
<div *ngIf="loading" class="spinner-overlay">
  <div class="spinner"></div>
  <p style="font-size: 20px; color: white">Loading...</p>
</div>

<router-outlet></router-outlet>
